import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, { useCallback, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useClientePage } from "../../../../Context/ClientePage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useUserInfor } from "../../../../Context/User";
import {
    BaixarExtratoPDFController,
    BaixarExtratoPDFViaContaController,
} from "../../../../Controllers/Cobranca/Extrato/ExtratoController";
import { ListarContatosController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import {
    GetDocumentoTemplateController,
    ListarDocumentoTemplateController,
    SetVariaveisDocumentoController,
} from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { EnviarEmailAnexoController } from "../../../../Controllers/Geral/Email/EmailController";
import { ListarEmailContaPorUsuarioController } from "../../../../Controllers/Geral/Grupos/GruposEmailsController";
import { IContaProduto } from "../../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import { IExtrato } from "../../../../Interfaces/Cobranca/Extrato/ExtratoInterface";
import TabelaDeExtrato from "./TabelaDeExtrato";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface IAtendimentoExtratoCliente {
    ID_EMPRESA: number;
    DS_OBRA: string;
    NR_VENDA: number;
    ID_CASO?: number;
    ID_CONTA: number;
    ID_PRODUTO: number;
    idTipoCaso?: number;
}
interface IPropsModal {
    setShow: (show: boolean) => void;
    Atendimento: IAtendimentoExtratoCliente;
    Produto?: IContaProduto;
}
interface PropsFormData {
    email_destinatario: string;
    email_remetente: number;
    assunto: string;
    file: Array<File>;
    cc: string;
    cco: string;
    ModeloEmail: number;
    DS_MENSAGEM: string;
}

export default function ExtradoDoCliente(props: IPropsModal) {
    const { ReloadHistorico } = useHistoricoContext();
    const { OrgInfor } = useUserInfor();

    const [buttonSpinner, setButtonSpinner] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [ButtonDisable, setButtonDisable] = useState(false);
    const { register, handleSubmit, formState, setValue, getValues, control } =
        useForm();
    const [base64, setBase64] = useState<string>();
    const { idModulo } = useAtendimentoPage();
    const [idDocumentoTemplate, setIdDocumentoTemplate] = useState(0);

    // const [uploading, setUploading] = useState(false);
    // const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    // console.log(uploadedImages);

    const { idCaso: idCasoClientePage, setIdCaso: setIdCasoClientePage } =
        useClientePage();

    const siengeMode = OrgInfor.COD_ERP_INTEGRACAO === "SIENGE";

    const tipoDeArquivo = "application/pdf";

    const { value: documentoTemplate } = useAsyncEffect(
        () => GetDocumentoTemplateController(idDocumentoTemplate),
        [idDocumentoTemplate]
    );

    useEffect(() => {
        ListarContatosController(props.Atendimento.ID_CONTA).then((res) => {
            setValue("email_destinatario", res[0].DS_EMAIL);
        });
    }, [props.Atendimento.ID_CONTA, setValue]);

    async function GerarExtrato() {
        const idCaso = props.Atendimento.ID_CASO ?? idCasoClientePage;
        const flTodosProdutos: boolean = getValues("FL_TODOS_PRODUTOS");
        const flReparceladas: boolean = getValues("FL_INCLUIR_REPARCELADAS");
        const flCanceladas: boolean = getValues("FL_INCLUIR_CANCELADAS");
        const flDistratadas: boolean = getValues("FL_INCLUIR_DISTRATADAS");
        const flRepactuacao: boolean = getValues("FL_INCLUIR_REPACTUACAO");
        const flSubjudice: boolean = getValues("FL_INCLUIR_SUBJUDICE");
        const flCorrigirVencimento: boolean = getValues(
            "FL_CORRIGIR_VENCIMENTO"
        );
        const flCorrigirAnuais: boolean = getValues("FL_CORRIGIR_ANUAIS");

        if (base64) return base64;

        const req: IExtrato = {
            ID_EMPRESA: props.Atendimento.ID_EMPRESA,
            ID_OBRA: props.Atendimento.DS_OBRA,
            ID_VENDA: props.Atendimento.NR_VENDA,
            ID_CASO: props.Atendimento.ID_CASO,
            FL_TODOS_PRODUTOS: flTodosProdutos,
            FL_INCLUIR_REPARCELADAS: flReparceladas,
            FL_INCLUIR_CANCELADAS: flCanceladas,
            FL_INCLUIR_DISTRATADAS: flDistratadas,
            FL_INCLUIR_REPACTUACAO: flRepactuacao,
            FL_INCLUIR_SUBJUDICE: flSubjudice,
            FL_CORRIGIR_VENCIMENTO: flCorrigirVencimento,
            FL_CORRIGIR_ANUAIS: flCorrigirAnuais,
        };

        let exec: (() => Promise<string>) | undefined = undefined;
        if (idCaso /*|| siengeMode*/) {
            exec = async () => BaixarExtratoPDFController(req);
        } else if (props.Atendimento.idTipoCaso) {
            exec = async () =>
                BaixarExtratoPDFViaContaController(
                    req,
                    props.Atendimento.ID_CONTA,
                    props.Atendimento.idTipoCaso!,
                    props.Atendimento.ID_CASO ?? 0
                ).then(async (res) => {
                    setIdCasoClientePage(res.ID_CASO);
                    return res.Extrato;
                });
        }

        if (exec) {
            setButtonSpinner(true);
            return exec()
                .then((res) => {
                    setBase64(res);
                    return res;
                })
                .finally(() => {
                    setButtonSpinner(false);
                });
        }
    }

    const listarDocumentosTemplateSimples = useCallback(() => {
        return ListarDocumentoTemplateController({ idTipoCaso: idModulo });
    }, [idModulo]);

    async function handleEnviarEmailFormSubmit(formData: PropsFormData) {
        // if (siengeMode) {
        //     const req: IExtrato = {
        //         ID_EMPRESA: props.Atendimento.ID_EMPRESA,
        //         ID_OBRA: props.Atendimento.DS_OBRA,
        //         ID_VENDA: props.Atendimento.NR_VENDA,
        //         DS_ASSUNTO: formData.assunto,
        //         DS_EMAIL: formData.email_destinatario,
        //         DS_MENSAGEM: formData.DS_MENSAGEM,
        //         ID_CASO: props.Atendimento.ID_CASO,
        //     };
        //     setLoading(true);
        //     BaixarExtratoPDFController(req)
        //         .then(() => {
        //             ReloadHistorico();
        //             props.setShow(false);
        //         })
        //         .finally(() => {
        //             setLoading(false);
        //         });
        // } else {
        const idCaso = props.Atendimento.ID_CASO ?? idCasoClientePage;

        const extratoB64 = await GerarExtrato();

        if (extratoB64) {
            setLoading(true);
            fetch(`data:${tipoDeArquivo};base64,${extratoB64}`)
                .then((r) => r.blob())
                .then(async (blob) => {
                    const file = new File([blob], "Extrato.pdf", {
                        type: tipoDeArquivo,
                    });
                    if (file && idCaso) {
                        return EnviarEmailAnexoController({
                            File: [file],
                            DS_ASSUNTO: formData.assunto,
                            DS_MENSAGEM: formData.DS_MENSAGEM,
                            ID_EMAIL_CONTA: formData.email_remetente,
                            ID_CASO: idCaso,
                            DS_DESTINATARIO: formData.email_destinatario,
                            DS_COPIA_CARBONO: formData.cc,
                            DS_COPIA_CARBONO_OCULTA: formData.cco,
                        })
                            .then((res) => {
                                props.setShow(false);
                                ReloadHistorico();
                            })
                            .catch(() => {
                                setLoading(false);
                            });
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
            // }
        }
    }

    return (
        <>
            <div className="col-12">
                <form
                    onSubmit={handleSubmit(handleEnviarEmailFormSubmit)}
                    className="w-100 align-itens-center mt-5"
                >
                    <div className="row d-flex flex-wrap">
                        <div className="col-12 col-lg-6 mt-2">
                            <LazySelect
                                name="email_remetente"
                                className={`form-control placeholder-dark-50  ${
                                    formState.errors.email_remetente &&
                                    "is-invalid"
                                }`}
                                ref={register({
                                    required: "Insira o email",
                                    valueAsNumber: true,
                                })}
                                controller={
                                    ListarEmailContaPorUsuarioController
                                }
                                getDS={(ec) => ec.DS_REMETENTE}
                                getKeyValue={(ec) => ec.ID_EMAIL_CONTA}
                                label="Email Remetente:"
                            />
                        </div>

                        <div className="col-12 col-lg-6 mt-2">
                            <label>Email Destinatário:</label>
                            <input
                                type="text"
                                name="email_destinatario"
                                placeholder={"Digite o email"}
                                className={`form-control px-0 p-2 placeholder-muted-75  ${
                                    formState.errors.email_destinatario &&
                                    "is-invalid"
                                }`}
                                ref={register({
                                    required: "Insira o email",
                                })}
                            />
                        </div>
                    </div>
                    {!siengeMode && (
                        <>
                            <div className="row mb-3 d-flex flex-wrap">
                                <div className="col-12 col-lg-6 mt-2">
                                    <label>Cópia Carbono:</label>
                                    <input
                                        type="text"
                                        name="cc"
                                        placeholder={
                                            "Digite o email para cópia"
                                        }
                                        className={`form-control px-0 p-2 placeholder-muted-75`}
                                        ref={register()}
                                    />
                                </div>

                                <div className="col-12 col-lg-6 mt-2">
                                    <label>Cópia Carbono Oculta:</label>
                                    <input
                                        type="text"
                                        name="cco"
                                        placeholder={
                                            "Digite o email para cópia oculta"
                                        }
                                        className={`form-control px-0 p-2 placeholder-muted-75`}
                                        ref={register()}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="row mb-3 d-flex flex-wrap">
                        <div className="col-12 col-lg-6">
                            <label>Assunto:</label>
                            <input
                                type="text"
                                name="assunto"
                                placeholder="Assunto:"
                                className={`form-control px-0 p-2 placeholder-muted-75 ${
                                    formState.errors.assunto && "is-invalid"
                                }`}
                                defaultValue={documentoTemplate?.DS_ASSUNTO}
                                ref={register({
                                    required: "",
                                })}
                            />
                        </div>
                        <div className="col-12 col-lg-6">
                            <LazySelect
                                label="Template de Email:"
                                className={`form-control placeholder-dark-50  ${
                                    formState.errors.ID_MODELO_EMAIL &&
                                    "is-invalid"
                                }`}
                                name="ModeloEmail"
                                ref={register({
                                    valueAsNumber: true,
                                })}
                                onChange={(e) => {
                                    if (e && props.Atendimento.ID_CASO) {
                                        setIdDocumentoTemplate(
                                            Number(e.target.value)
                                        );
                                        setButtonDisable(true);
                                        SetVariaveisDocumentoController(
                                            Number.parseInt(e.target.value),
                                            props.Atendimento.ID_CASO,
                                            props.Atendimento.idTipoCaso ?? 2
                                        )
                                            .then((res) => {
                                                setValue("DS_MENSAGEM", res);
                                                setButtonDisable(false);
                                            })
                                            .catch(() => {
                                                setButtonDisable(false);
                                            });
                                    }
                                }}
                                controller={listarDocumentosTemplateSimples}
                                getDS={(dt) => dt.DS_DOCUMENTO}
                                getKeyValue={(dt) => dt.ID_DOCUMENTO_TEMPLATE}
                            >
                                <option>Modelo de email</option>
                            </LazySelect>
                        </div>
                    </div>

                    {siengeMode && (
                        <div
                            className="accordion accordion-toggle-arrow mb-3"
                            id="accordionExample1"
                        >
                            <div className="card">
                                <div className="card-header">
                                    <div
                                        className="card-title"
                                        data-toggle="collapse"
                                        data-target="#collapseOne1"
                                    >
                                        Filtros
                                    </div>
                                </div>
                                <div
                                    id="collapseOne1"
                                    className="collapse"
                                    data-parent="#accordionExample1"
                                >
                                    <div className="card-body">
                                        <div className="row">
                                            <span className="col-4">
                                                Incluir todos os produtos?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_TODOS_PRODUTOS"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                            <span className="col-4">
                                                Incluir parcelas reparceladas?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_INCLUIR_REPARCELADAS"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <span className="col-4">
                                                Incluir parcelas canceladas?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_INCLUIR_CANCELADAS"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                            <span className="col-4">
                                                Incluir parcelas distratadas?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_INCLUIR_DISTRATADAS"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <span className="col-4">
                                                Incluir baixas por repactuação?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_INCLUIR_REPACTUACAO"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                            <span className="col-4">
                                                Incluir títulos sub judice?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_INCLUIR_SUBJUDICE"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <span className="col-4">
                                                Corrigir valor até o vencimento?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_CORRIGIR_VENCIMENTO"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                            <span className="col-4">
                                                Corrigir valor do saldo com
                                                correção anual?
                                            </span>
                                            <div className="col-2">
                                                <span
                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center m-0"
                                                    data-toggle="tooltip"
                                                >
                                                    <label>
                                                        <input
                                                            name="FL_CORRIGIR_ANUAIS"
                                                            type="checkbox"
                                                            defaultChecked={
                                                                false
                                                            }
                                                            ref={register({})}
                                                        />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mb-3 d-flex flex-wrap">
                        {Loading ? (
                            <button
                                type="button"
                                className="btn btn-sm btn-shadow btn-primary m-1"
                            >
                                <div className="row px-4">
                                    <div className="loading-component">
                                        <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Carregando...
                                            </span>
                                        </div>
                                    </div>
                                    <div className="ml-2">
                                        Enviar Extrato por Email
                                    </div>
                                </div>
                            </button>
                        ) : (
                            <button
                                className="btn btn-sm btn-shadow btn-primary m-1"
                                disabled={
                                    ButtonDisable || Loading || buttonSpinner
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faPaperPlane}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Enviar Extrato por Email
                            </button>
                        )}

                        {siengeMode && (
                            <button
                                type="button"
                                className="btn btn-sm btn-shadow btn-info m-1"
                                disabled={!!base64 || Loading || buttonSpinner}
                                onClick={() => {
                                    GerarExtrato();
                                }}
                            >
                                <i className="flaticon-edit-1"></i>
                                Baixar Extrato do Cliente
                            </button>
                        )}
                        {!siengeMode && (
                            <>
                                {buttonSpinner ? (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-shadow btn-success m-1"
                                    >
                                        <div className="row px-4">
                                            <div className="loading-component">
                                                <div
                                                    className="spinner-border spinner-border-sm text-light"
                                                    role="status"
                                                >
                                                    <span className="sr-only">
                                                        Carregando...
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="ml-2">
                                                Extrato Cliente
                                            </div>
                                        </div>
                                    </button>
                                ) : (
                                    <>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-shadow btn-success m-1"
                                            disabled={
                                                !!base64 ||
                                                Loading ||
                                                buttonSpinner
                                            }
                                            onClick={() => {
                                                if (!base64) {
                                                    GerarExtrato();
                                                }
                                            }}
                                        >
                                            <i className="flaticon-edit-1"></i>
                                            Gerar Extrato do Cliente
                                        </button>
                                    </>
                                )}
                            </>
                        )}
                    </div>

                    <div className="col-12 h-100 mt-4">
                        <Controller
                            name="DS_MENSAGEM"
                            defaultValue=""
                            control={control}
                            render={(field) => (
                                <>
                                    {/* {uploading && (
                                        <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                            Fazendo upload de imagem{" "}
                                            <Spinner
                                                size="sm"
                                                color="primary"
                                            />
                                        </div>
                                    )} */}
                                    <FroalaEditor
                                        value={field.value ?? ""}
                                        onChange={field.onChange}
                                        onImageUploadStart={() => false}
                                        onImageUploadEnd={() => false}
                                    />
                                </>
                            )}
                        />
                    </div>
                </form>
            </div>
            <div className="col-12">
                <div className="d-flex justify-content-start align-items-center mt-6">
                    {base64 && (
                        <object
                            type="application/pdf"
                            data={"data:application/pdf;base64," + base64}
                            style={{ width: "100%", height: "300px" }}
                        >
                            Extrato do Cliente em PDF
                        </object>
                    )}
                </div>
            </div>

            {siengeMode && (
                <div className="col-12">
                    <TabelaDeExtrato
                        DS_OBRA={props.Atendimento.DS_OBRA}
                        ID_EMPRESA={props.Atendimento.ID_EMPRESA}
                        NR_VENDA={props.Atendimento.NR_VENDA}
                    />
                </div>
            )}
        </>
    );
}
